import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Layout from "../../components/layout";
import ProcessReceiveList from "../../components/processReceives/ProcessReceiveList";
import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../features/settings/settingsSlice";
import { useCanAccess } from "../../hooks/useCanAccess";
import { useProcessDefinitionFromQuery } from "../../hooks/useProcessDefinitionFromQuery";
import { localizedProcessName } from "../../lib/utils";
import { route } from "../../static/route";
import { t } from "../../locales";

const ProcessReceivesPage = () => {
  const navigate = useNavigate();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);
  const canAccess = useCanAccess();
  const { processDefinition, loading } = useProcessDefinitionFromQuery(t.processReceives.processNotSupported);

  useEffect(() => {
    if (loggingUser?.permissions && selectedBranch && !canAccess("process-receives.menu")) {
      navigate(route.dashboard);
    }
  }, [loggingUser, selectedBranch]);

  return (
    <Layout>
      <div className="px-2 py-4 md:px-6 md:py-6">
        <nav className="text-sm font-semibold text-gray-500 mb-4">
          <Link to={route.dashboard} className="text-brand-dark hover:underline">
            {t.processReceives.breadcrumbHome}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.processReceives.breadcrumbList}</span>
        </nav>
        <h1 className="text-2xl font-bold text-brand-dark mb-6">
          {processDefinition ? `${localizedProcessName(processDefinition)} — ${t.processReceives.pageTitle}` : t.processReceives.pageTitle}
        </h1>
        {loading || !processDefinition ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-[#113F67]" />
          </div>
        ) : (
          <ProcessReceiveList processDefinition={processDefinition} />
        )}
      </div>
    </Layout>
  );
};

export default ProcessReceivesPage;
